export default "__VITE_ASSET__DM5vB2xg__"